(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmFilterController', AlarmFilterController);

    AlarmFilterController.$inject = ['$scope', '$rootScope', '$stateParams', '$state', '$filter', '$locale', '$timeout', 'AlarmService', 'OltService', 'OnuService'];

    function AlarmFilterController($scope, $rootScope, $stateParams, $state, $filter, $locale, $timeout, AlarmService, OltService, OnuService) {

        var vm = this;

        // Comboboxes content
        vm.equipmentTypeList = ['OLT', 'ONU'];
        vm.equipmentList = [];
        vm.interfaceList = [];
        vm.onuList = [];
        vm.datepicker = [];
        vm.time = [];
        vm.typesList = [];

        // Comboboxes actions
        vm.setEquipmentType = setEquipmentType;
        vm.setEquipment = setEquipment;
        vm.setDate = setDate;
        vm.setDatePeriod = setDatePeriod;
        vm.setTime = setTime;

        // Filter actions
        vm.toggleFilter = toggleFilter;
        vm.applyFilter = applyFilter;
        vm.clearFilter = clearFilter;

        // Initialize fields values verifying params
        initialize();
        configDateTimePicker();
        verifyParams();
        clearFilter();
        // Requests
        AlarmService.getInterfaces().then(successInterface);
        AlarmService.getAlarmType().then(successType);

        // Actions functions
        function toggleFilter() {
            vm.open = !vm.open;
        }

        function setEquipmentType(equipmentType) {

            clearFields(['equipment', 'onu']);

            if (equipmentType) {
                vm.filter.equipmentType = equipmentType;
            }

            vm.equipmentList = [];
            vm.filter.equipment = null;
            vm.placeholder.name = 'global.common.loading';

            switch (vm.filter.equipmentType) {
                case 'OLT':
                    vm.filter.onu = null;
                    vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';
                    return OltService.listOlts(null, true).then(function (data) {
                        vm.equipmentList = data;
                        if (data.length) {
                            vm.filter.equipment = {};
                            vm.placeholder.name = '';
                            vm.equipmentList.unshift({});
                        } else {
                            vm.filter.equipment = null;
                            vm.placeholder.name = 'alarm.filter.placeholder.noOltFound';
                        }
                    });
                case 'ONU':
                    return OnuService.getAuthorizedOnuList(null, true).then(function (data) {
                        vm.equipmentList = data;
                        if (data.length) {
                            vm.filter.equipment = {};
                            vm.placeholder.name = '';
                            vm.equipmentList.unshift({});
                        } else {
                            vm.filter.equipment = null;
                            vm.placeholder.name = 'alarm.filter.placeholder.noOnuFound';
                        }
                    });
            }

        }

        function setEquipment(equipment) {

            clearFields(['onu']);

            if (equipment) {
                vm.filter.equipment = equipment;
            }

            if (vm.filter.equipmentType == 'OLT') {
                vm.onuList = [];
                vm.filter.onu = null;
                vm.placeholder.onu = 'alarm.filter.placeholder.selectOlt';
                if (vm.filter.equipment && vm.filter.equipment.id) {
                    vm.placeholder.onu = 'global.common.loading';
                    OnuService.getAuthorizedOnuList({oltId: vm.filter.equipment.id}, true).then(successOnuList);
                }
            }

        }

        function setDate() {

            var initial = '';
            var final = '';
            var fullDate = '';

            if (vm.datepicker.initial.selected) {
                initial = $filter('date')(vm.datepicker.initial.selected, 'mediumDate');
            }

            if (vm.datepicker.final.selected) {
                final = $filter('date')(vm.datepicker.final.selected, 'mediumDate');
            }

            if (initial && final) {
                if (initial == final) {
                    fullDate = initial;
                } else {
                    fullDate = initial + ' ' + $filter('translate')('alarm.filter.to') + ' ' + final;
                }
            }

            if (initial && !final) {
                fullDate = $filter('translate')('alarm.filter.start') + ': ' + initial;
            }

            if (!initial && final) {
                fullDate = $filter('translate')('alarm.filter.end') + ': ' + final;
            }

            vm.filter.date.initial = vm.datepicker.initial.selected;
            vm.filter.date.final = vm.datepicker.final.selected;
            vm.filter.date.applied = fullDate;
            vm.datepicker.toggle(false, 'applying');

        }

        var cleanListener = $rootScope.$on('$localeChangeSuccess', function () {
            setDate();
            setTime();
        });
        $scope.$on('$destroy', cleanListener);

        function setDatePeriod(period) {
            var today = new Date();
            var yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
            var weekAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
            var monthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
            var periods = {
                'today': [today, today],
                'yesterday': [yesterday, yesterday],
                'last-week': [weekAgo, today],
                'last-month': [monthAgo, today]
            };
            vm.datepicker.initial.selected = periods[period][0];
            vm.datepicker.final.selected = periods[period][1];
        }

        function setTime() {
            if (vm.time.initial.hour.value && vm.time.initial.minute.value
                    && vm.time.final.hour.value && vm.time.final.minute.value) {
                vm.filter.time = vm.time.initial.hour.value + 'h' + vm.time.initial.minute.value + 'min';
                vm.filter.time += ' ' + $filter('translate')('alarm.filter.to') + ' ';
                vm.filter.time += vm.time.final.hour.value + 'h' + vm.time.final.minute.value + 'min';
                vm.time.toggle(false);
            }
        }

        function clearDate() {
            vm.filter.date.initial = '';
            vm.filter.date.final = '';
            vm.filter.date.applied = '';
            vm.datepicker.initial.selected = '';
            vm.datepicker.initial.previous = '';
            vm.datepicker.final.selected = '';
            vm.datepicker.final.previous = '';
        }

        function clearTime() {
            vm.filter.time = '';
            vm.time.initial.hour = {label: '--h'};
            vm.time.initial.minute = {label: '--min'};
            vm.time.final.hour = {label: '--h'};
            vm.time.final.minute = {label: '--min'};
        }

        function clearFields(fields) {
            fields.forEach(function (field) {
                vm.filter[field] = {};
                vm[field + 'List'] = [];
            });
        }

        function applyFilter() {
            if (vm.time.initial.hour.value && vm.time.initial.minute.value
                    && vm.time.final.hour.value && vm.time.final.minute.value
                    && (!vm.datepicker.initial.selected || !vm.datepicker.final.selected)
                    && !vm.filter.withinTimeOnly) {
                errorList({status: '400.1', config: {}});
            } else if (vm.filter.equipmentType == 'ONU' && !vm.filter.equipment.name) {
                errorList({status: '400.2', config: {}});
            } else {
                getAlarmList(getFilter());
                getData();
            }
        }

        function clearFilter() {
            initialize();
            setEquipmentType('OLT');
            clearDate();
            clearTime();
            getAlarmList();
            getData();
        }

        // Helper functions
        function getFilter() {

            var filter = {};

            if (vm.filter.equipment && vm.filter.equipment.id) {
                switch (vm.filter.equipmentType) {
                    case 'OLT':
                        filter.oltId = vm.filter.equipment.id;
                        break;
                    case 'ONU':
                        filter.onuId = vm.filter.equipment.id;
                        break;
                }
            }

            filter.interface = vm.filter.interface.value;

            if (vm.filter.onu && vm.filter.onu.id) {
                filter.onuId = vm.filter.onu.id;
            }

            if (vm.filter.date.initial) {
                filter.initialDate = $filter('date')(vm.filter.date.initial, 'yyyy-MM-dd');
            }

            if (vm.filter.date.final) {
                filter.endDate = $filter('date')(vm.filter.date.final, 'yyyy-MM-dd');
            }

            if (vm.time.initial.hour.value) {
                filter.initialTime = vm.time.initial.hour.value + ':' + vm.time.initial.minute.value + ':00';
                filter.endTime = vm.time.final.hour.value + ':' + vm.time.final.minute.value + ':59';
            }

            if (vm.time.initial.hour.value && vm.time.final.hour.value) {
                filter.withinTimeOnly = vm.filter.withinTimeOnly;
            }
            filter.alarmType = vm.filter.alarmType.value;
            filter.severity = setSeverity();

            return filter;
        }

        function setSeverity() {
            var severity = [];
            for (var item in vm.filter.severity) {
                if (vm.filter.severity[item]) {
                    severity.push(item.toUpperCase());
                }
            }
            return severity.join();
        }

        function verifyParams() {
            if ($stateParams.id && $stateParams.type) {
                vm.open = true;
                setEquipmentType($stateParams.type).then(function () {
                    angular.forEach(vm.equipmentList, function (item) {
                        if (item.id == $stateParams.id) {
                            setEquipment(item);
                            getAlarmList(getFilter());
                            getData(vm.currentPage);
                        }
                    });
                });
            } else {
                setEquipmentType('OLT');
                getAlarmList(getFilter());
                getData();
            }
        }

        function getData() {
            if (getFilter()) {
                var data = angular.copy(getFilter());         
                data.currentPage = 0;
            } else {
                var data = {
                    currentPage : 0
                }
            }
            AlarmService.getAlarmHistoryList(data).then(successHistoryList).catch(errorList);                        
        }
        // Request Functions
        function getAlarmList(filter) {
            AlarmService.getAlarmList(filter).then(successList).catch(errorList);            
        }

        // Request Callbacks
        function successInterface(data) {
            vm.interfaceList = data.map(stringToObject);
            vm.interfaceList.unshift({});
        }

        function successType(data) {
            vm.typesList = data.map(stringToObject);
            vm.typesList.unshift({});
        }

        function successList(data) {
            $rootScope.$emit('filterDataUpdate', data);
        }

        
        function successHistoryList(data) {
            $rootScope.$emit('filterDataUpdateHistory', data);         
        }
        

        function errorList(response) {
            AlarmService.errorModalConstructor(response, 'filter');
        }

        function successOnuList(data) {
            vm.onuList = data;
            if (data.length) {
                vm.filter.onu = {};
                vm.placeholder.onu = '';
                vm.onuList.unshift({});
            } else {
                vm.filter.onu = null;
                vm.placeholder.onu = 'alarm.filter.placeholder.noOnuFound';
            }
        }

        // Helper Functions
        function listHours() {
            var hours = [];
            var hour = '';
            for (var i = 0; i < 24; i++) {
                hour = (i < 10 ? '0' : '') + i;
                hours.push({value: hour, label: hour + 'h'});
            }
            return hours;
        }

        function listMinutes() {
            var minutes = [];
            var minute = '';
            for (var i = 0; i < 60; i++) {
                minute = (i < 10 ? '0' : '') + i;
                minutes.push({value: minute, label: minute + 'min'});
            }
            return minutes;
        }

        function stringToObject(item) {
            return {value: item};
        }

        function initialize() {
            vm.filter = {
                equipmentType: 'OLT',
                equipment: {},
                interface: {},
                onu: null,
                date: {
                    initial: '',
                    final: '',
                    applied: ''
                },
                time: '',
                withinTimeOnly: false,
                alarmType: {},
                severity: {
                    warning: false,
                    minor: false,
                    major: false,
                    critical: false
                }
            };
            vm.placeholder = {
                name: '',
                onu: ''
            };
        }

        function configDateTimePicker() {
            /* eslint-disable angular/controller-as-vm */
            var today = new Date();
            vm.datepicker = {
                open: false,
                toggle: function (open, applying) {
                    if (!applying && this.open) {
                        if (vm.filter.date.initial) {
                            vm.datepicker.initial.selected = vm.filter.date.initial;
                            vm.datepicker.initial.previous = vm.filter.date.initial;
                        }
                        if (vm.filter.date.final) {
                            vm.datepicker.final.selected = vm.filter.date.final;
                            vm.datepicker.final.previous = vm.filter.date.final;
                        }
                    }
                    this.open = angular.isDefined(open) ? open : !this.open;
                },
                clear: function () {
                    clearDate();
                    this.toggle(false);
                },
                initial: {
                    previous: '',
                    selected: '',
                    change: changeInitialDate,
                    options: {
                        formatDay: 'd',
                        formatMonth: 'MMM',
                        formatYear: 'yy',
                        minDate: new Date(2000, 0, 1),
                        startingDay: 1,
                        showWeeks: false,
                        customClass: customClassInitial
                    }
                },
                final: {
                    previous: '',
                    selected: '',
                    change: changeFinalDate,
                    options: {
                        formatDay: 'd',
                        formatMonth: 'MMM',
                        formatYear: 'yy',
                        minDate: new Date(2000, 0, 1),
                        initDate: new Date(today.getFullYear(), today.getMonth() + 1, 1),
                        startingDay: 1,
                        showWeeks: false,
                        customClass: customClassFinal
                    }
                }
            };

            vm.time = {
                open: false,
                toggle: function (open) {
                    this.open = angular.isDefined(open) ? open : !this.open;
                },
                clear: function () {
                    clearTime();
                    this.toggle(false);
                },
                initial: {
                    hours: listHours(),
                    minutes: listMinutes(),
                    hour: '',
                    minute: ''
                },
                final: {
                    hours: listHours(),
                    minutes: listMinutes(),
                    hour: '',
                    minute: ''
                }
            };

            function customClassInitial(data) {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var date = data.date.setHours(0, 0, 0, 0);

                if (!initial) {
                    return
                }

                initial = initial.setHours(0, 0, 0, 0);
                final = final && final.setHours(0, 0, 0, 0);

                if (final && date > initial && date < final) {
                    return 'selected';
                }

                if (date == initial || date == final) {
                    return 'edge';
                }

            }

            function customClassFinal(data) {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var date = data.date.setHours(0, 0, 0, 0);

                if (!final) {
                    return
                }

                final = final.setHours(0, 0, 0, 0);
                initial = initial && initial.setHours(0, 0, 0, 0);

                if (initial && date > initial && date < final) {
                    return 'selected';
                }

                if (date == final || date == initial) {
                    return 'edge';
                }

            }

            function changeInitialDate() {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var previous = vm.datepicker.initial.previous;

                if (previous && previous.getTime() == initial.getTime()) {
                    vm.datepicker.initial.selected = '';
                    vm.datepicker.initial.previous = '';
                    if (final) {
                        vm.datepicker.final.selected = new Date(final);
                    }
                } else {
                    if (initial > final) {
                        vm.datepicker.final.selected = '';
                    } else {
                        vm.datepicker.final.selected = new Date(final);
                    }
                    vm.datepicker.initial.previous = initial;
                }

            }

            function changeFinalDate() {

                var initial = vm.datepicker.initial.selected;
                var final = vm.datepicker.final.selected;
                var previous = vm.datepicker.final.previous;

                if (previous && previous.getTime() == final.getTime()) {
                    vm.datepicker.final.selected = '';
                    vm.datepicker.final.previous = '';
                    if (initial) {
                        vm.datepicker.initial.selected = new Date(initial);
                    }
                } else {
                    if (final < initial) {
                        vm.datepicker.initial.selected = '';
                    } else if (initial) {
                        vm.datepicker.initial.selected = new Date(initial);
                    }
                    vm.datepicker.final.previous = final;
                    vm.datepicker.initial.options.initDate = new Date(final.getFullYear(), final.getMonth() - 1, 1)
                }

            }
            /* eslint-enable angular/controller-as-vm */
        }
    }

})();
